interface BuildSizeColumnsOptions {
	haveOnlyOneWarehouse: boolean;
	isDeliveryBySupplier: boolean;
	havePartInventory: boolean;
	hasNotQuoteSelected?: boolean;
	hasCollumnAction?: boolean;
}

export function buildSizeColumns({
	haveOnlyOneWarehouse,
	isDeliveryBySupplier,
	havePartInventory,
	hasNotQuoteSelected = false,
	hasCollumnAction = false,
}: BuildSizeColumnsOptions): string[] {
	// 'responsive' makes the requestedPart column fill all remaining space
	const columns: string[] = [
		"responsive", // requestedPart — flexible, uses all remaining width
		"130px", // partNumber
		"110px", // partType
	];

	if (!haveOnlyOneWarehouse) columns.push("110px"); // warehouse

	columns.push(
		"150px", // sku — fits 10 characters without truncating
		"70px", // amount
		"115px", // price — fits 99,999.00 without truncating
		"65px", // pickupDays
	);

	if (!isDeliveryBySupplier) {
		columns.push("130px"); // dimensions (H x W x D)
		columns.push("75px"); // weight
	}

	columns.push("70px"); // backOrder
	columns.push(hasNotQuoteSelected ? "110px" : "65px"); // notQuote (+ reason when selected)

	if (havePartInventory && hasCollumnAction) {
		columns.push("130px"); // inventory details + edit/save/cancel icons
	} else {
		if (havePartInventory) {
			columns.push("80px"); // inventory details
		}
		if (hasCollumnAction) {
			columns.push("50px"); // action column for edit icon
		}
	}
	return columns;
}
